import {Component} from '@angular/core';
import {ResolverService} from './core/services/resolver.service';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import {AuthService} from './auth/auth.service';
import {ErrorService, ErrorType} from './core/services/error.service';
import {ToastrService} from 'ngx-toastr';
import {ComponentBase} from './core/entities/component-base';
import {LanguageService} from './services/language.service';
import {CardConditionService} from './services/card-condition.service';
import {WarehouseService} from './services/warehouse.service';
import {environment} from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent extends ComponentBase {
  title = 'app';
  isProduction = environment.production;
  apiUrl = environment.apiUrl;
  productionUrl = 'api/';
  localUrl = 'http://localhost:8080/v1/';

  constructor( private resS: ResolverService, private _authService: AuthService, private _router: Router, private _errorService: ErrorService, private _toastrService: ToastrService,
              //stanno qua per caricarli per primi è una zozzata per il mometno
               private cardCondService: CardConditionService,
               private warehouseService: WarehouseService,
               private languageService: LanguageService
               ) {


    super();
    const me = this;

    this._errorService.onError.subscribe(
      err => {
        this.spinnerService.hide();
        if ( err ) {
          const key = 'error.' + ErrorType[err.type] + '.' + err.error.name;
          me.a_translate(key).subscribe(
            msg => {
              if (msg != key){
                me._toastrService.error(msg + (err.error && err.error.message ? ' ' + err.error.message : '')) ;
              } else {
                me._toastrService.error( err.error.message ? err.error.message : 'Error connecting to the server');
              }

            }
          );
        }
      }
    );
    this._authService.logoutEvent.subscribe(u => {
      console.log('AppComponent.logoutEvent.redirect', u);
      //window.location.reload();
      this._router.navigateByUrl('/');
    }
    );
    this._router.events.subscribe( event => {
       if (event instanceof NavigationStart){
         this.spinnerService.show();
         this._authService.setRouteChange();
       } else if ( event instanceof  NavigationEnd){
         this.spinnerService.hide();
       }
    } );


  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts